import { useCallback, useState } from "react";
import check from "skin/entry/query/check";

export default function usePhone(phone, setPhone) {
	const [num, setNum] = useState('');
	const [status, setStatus] = useState({ type: null, message: null });
	const onNumChange = useCallback(ev => {
		const v = ev.target.value.replace(/[^0-9]/g, '');
		setNum(v);
		setPhone('');
		setStatus(p => {
			p.abortController?.abort?.();
			return { type: null, message: null };
		});
	}, []);

	const request = () => {
		const v = num.replace(/[^0-9]/g, '');
		if (v.length !== 11) {
			setStatus({ type: 'error', message: 'Указан некорректный номер' })
			return
		};
		const ac = new AbortController();
		setStatus({ type: 'pending', message: 'Отправляем код подтверждения...', abortController: ac })
		check(num, ac.signal)
		.then(message => {
			if (!message) return;
			setStatus({ type: 'ok', message })
		})
		.catch(err => {
			setStatus({ type: 'error', message: err.toString() })
		})
	};

	const submitPhone = useCallback(() => setPhone(num), [num]);

	return { num, onNumChange, status, request, submitPhone }
}